import { css as b, LitElement as u, nothing as n, html as p } from "lit";
import { property as e, customElement as g } from "lit/decorators.js";
import { classMap as h } from "lit/directives/class-map.js";
import { b as v, f as m } from "./styles-scZ6dVz-.js";
import { b as y, a as f } from "./events-CkEPl0SM.js";
var x = Object.defineProperty, k = Object.getOwnPropertyDescriptor, o = (r, i, s, l) => {
  for (var a = l > 1 ? void 0 : l ? k(i, s) : i, d = r.length - 1, c; d >= 0; d--)
    (c = r[d]) && (a = (l ? c(i, s, a) : c(a)) || a);
  return l && a && x(i, s, a), a;
};
let t = class extends u {
  constructor() {
    super(...arguments), this.variant = "primary", this.size = "md", this.disabled = !1, this.loading = !1, this.type = "button", this.iconOnly = !1, this.label = null;
  }
  connectedCallback() {
    super.connectedCallback(), this.setAttribute("role", "presentation"), this.migrateAriaLabelToLabel();
  }
  updated(r) {
    super.updated?.(r), this.migrateAriaLabelToLabel();
  }
  /**
   * Migrates aria-label attribute from host to the internal label property.
   * This allows consumers to use the familiar aria-label attribute while
   * ensuring proper accessibility by moving it to the internal button.
   */
  migrateAriaLabelToLabel() {
    if (this.hasAttribute("aria-label")) {
      const r = this.getAttribute("aria-label");
      r && !this.label && (this.label = r), this.removeAttribute("aria-label");
    }
  }
  handleClick(r) {
    if (this.disabled || this.loading) {
      r.preventDefault(), r.stopPropagation();
      return;
    }
    y(this, f.CLICK, { originalEvent: r });
  }
  render() {
    const r = {
      [this.variant]: !0,
      [this.size]: !0,
      loading: this.loading,
      "icon-only": this.iconOnly,
      "focus-ring": !0
    };
    return p`
      <button
        part="button"
        type=${this.type}
        class=${h(r)}
        ?disabled=${this.disabled || this.loading}
        name=${this.name ?? n}
        value=${this.value ?? n}
        aria-label=${this.label || n}
        title=${this.title || n}
        aria-busy=${this.loading ? "true" : n}
        aria-disabled=${this.disabled ? "true" : n}
        @click=${this.handleClick}
      >
        <slot name="prefix"></slot>
        <slot></slot>
        <slot name="suffix"></slot>
      </button>
    `;
  }
};
t.styles = [
  v,
  m,
  b`
      :host {
        display: inline-flex;
      }

      button {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: var(--r5-space-2);
        border-radius: var(--r5-radius-md);
        font-weight: var(--r5-font-medium);
        font-family: inherit;
        font-size: inherit;
        cursor: pointer;
        border: 1px solid transparent;
        transition-property: background-color, border-color, color, box-shadow;
        transition-duration: var(--r5-duration-fast);
        transition-timing-function: var(--r5-ease-default);
        white-space: nowrap;
        user-select: none;
        text-decoration: none;
        width: 100%;
      }

      button:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }

      /* Size variants */
      button.sm {
        height: var(--r5-button-height-sm);
        padding: 0 var(--r5-button-padding-x-sm);
        font-size: var(--r5-text-xs);
      }

      button.md {
        height: var(--r5-button-height-md);
        padding: 0 var(--r5-button-padding-x-md);
        font-size: var(--r5-text-sm);
      }

      button.lg {
        height: var(--r5-button-height-lg);
        padding: 0 var(--r5-button-padding-x-lg);
        font-size: var(--r5-text-base);
      }

      /* Primary variant */
      .primary {
        background-color: var(--r5-button-bg, var(--r5-color-primary-600));
        color: var(--r5-button-color, white);
        border-color: var(--r5-button-border-color, var(--r5-color-primary-600));
      }

      .primary:hover:not(:disabled) {
        background-color: var(--r5-button-hover-bg, var(--r5-color-primary-700));
        border-color: var(--r5-color-primary-700);
      }

      .primary:active:not(:disabled) {
        background-color: var(--r5-button-active-bg, var(--r5-color-primary-800));
      }

      /* Secondary variant */
      .secondary {
        background-color: var(--r5-bg-muted);
        color: var(--r5-text);
        border-color: var(--r5-border);
      }

      .secondary:hover:not(:disabled) {
        background-color: var(--r5-color-neutral-200);
        border-color: var(--r5-color-neutral-300);
      }

      .secondary:active:not(:disabled) {
        background-color: var(--r5-color-neutral-300);
      }

      /* Danger variant */
      .danger {
        background-color: var(--r5-color-danger-600);
        color: white;
        border-color: var(--r5-color-danger-600);
      }

      .danger:hover:not(:disabled) {
        background-color: var(--r5-color-danger-700);
        border-color: var(--r5-color-danger-700);
      }

      .danger:active:not(:disabled) {
        background-color: var(--r5-color-danger-800);
      }

      /* Ghost variant */
      .ghost {
        background-color: transparent;
        color: var(--r5-text);
        border-color: transparent;
      }

      .ghost:hover:not(:disabled) {
        background-color: var(--r5-bg-muted);
      }

      .ghost:active:not(:disabled) {
        background-color: var(--r5-color-neutral-200);
      }

      /* Outline variant */
      .outline {
        background-color: transparent;
        color: var(--r5-text);
        border-color: var(--r5-border);
      }

      .outline:hover:not(:disabled) {
        background-color: var(--r5-bg-subtle);
        border-color: var(--r5-color-neutral-300);
      }

      .outline:active:not(:disabled) {
        background-color: var(--r5-bg-muted);
      }

      /* Loading state */
      .loading {
        position: relative;
        color: transparent !important;
        pointer-events: none;
      }

      .loading::after {
        content: '';
        position: absolute;
        width: 1em;
        height: 1em;
        top: 50%;
        left: 50%;
        margin-top: -0.5em;
        margin-left: -0.5em;
        border: 2px solid currentColor;
        border-right-color: transparent;
        border-radius: 50%;
        animation: ark-button-spin 0.6s linear infinite;
      }

      .primary.loading::after,
      .danger.loading::after {
        border-color: white;
        border-right-color: transparent;
      }

      @keyframes ark-button-spin {
        to {
          transform: rotate(360deg);
        }
      }

      /* Icon-only mode */
      button.icon-only {
        padding: 0;
        aspect-ratio: 1;
      }

      button.icon-only.sm {
        width: var(--r5-button-height-sm);
      }

      button.icon-only.md {
        width: var(--r5-button-height-md);
      }

      button.icon-only.lg {
        width: var(--r5-button-height-lg);
      }

      /* Slot styling - ensure slotted content inherits button font-size */
      ::slotted(*) {
        font-size: inherit;
      }

      ::slotted([slot='prefix']),
      ::slotted([slot='suffix']) {
        display: inline-flex;
        align-items: center;
      }
    `
];
o([
  e({ type: String, reflect: !0 })
], t.prototype, "variant", 2);
o([
  e({ type: String, reflect: !0 })
], t.prototype, "size", 2);
o([
  e({ type: Boolean, reflect: !0 })
], t.prototype, "disabled", 2);
o([
  e({ type: Boolean, reflect: !0 })
], t.prototype, "loading", 2);
o([
  e({ type: String })
], t.prototype, "type", 2);
o([
  e({ type: Boolean, attribute: "icon-only" })
], t.prototype, "iconOnly", 2);
o([
  e({ type: String })
], t.prototype, "name", 2);
o([
  e({ type: String })
], t.prototype, "value", 2);
o([
  e({ type: String, attribute: "label" })
], t.prototype, "label", 2);
t = o([
  g("ark-button")
], t);
export {
  t as A
};
//# sourceMappingURL=ark-button-DYI_xPdn.js.map
